module.exports = __webpack_public_path__ + "img/cabinet_color.252c429a.svg";